/**
 * Build chart data for Discount Amount by Day of Week.
 */
export function getDayOfWeekDiscountChartData(discountAmountsPerDay) {
  const labels = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return { labels, discountData: discountAmountsPerDay };
}

/**
 * Build Highcharts options for Discount Amount by Day of Week (column).
 */
export function getDayOfWeekChartOptions({ labels, discountData }) {
  return {
    chart: { type: "column" },
    title: { text: null },
    xAxis: {
      categories: labels,
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: { text: "Discount Amount (PHP)" },
      labels: {
        formatter() {
          return "\u20B1" + this.value.toLocaleString();
        },
      },
    },
    tooltip: {
      valuePrefix: "\u20B1",
      valueDecimals: 2,
    },
    plotOptions: {
      column: {
        borderRadius: 4,
        colorByPoint: false,
      },
    },
    series: [
      {
        name: "Discount Amount",
        data: discountData,
        color: "#ea4335",
      },
    ],
    credits: { enabled: false },
  };
}
